import { useEffect, useRef, useState } from "react";
import { LoadingPlaceholder } from "../../add_ons/AddOns";
import { baseEndPoint, DEBUG } from "../../utils";


import '../../../component_styles/landing/blog.css';
import NewsGrid from "../news/NewsGrid";


const HomepageBlogSnippet = () => {
 
    const APINewsUpdate = useRef(null)
    const [data, setData] = useState(null)
    const [errorOnDataLoad, setErrorOnDataLoad] = useState(false)
    const [updateAPINews, setUpdateAPINews] = useState(false)
    
    const getRandomInt = (min, max) => {
        min = Math.ceil(min);   // inclusive
        max = Math.floor(max);  // inclusive
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const getNewsIOData = () => { 
        const searchTerms = [
            "Israel",
            "Russia",
            "Ukraine",
            "protest",
            "Democrat",
            "war",
            "Hamas",
            "donation",
        ];

        const apiToken = "pub_faabe52f4a214ea49b3cecf7afc668af"//"679yO9RDGmpPEsu5d1V3Vsr3d42WzSGDDkrz6ZQA"
        
        // Join the terms into a single search query, separated by commas (OR search)
        const category = searchTerms[getRandomInt(0,(searchTerms.length-1))]

        const params = new URLSearchParams({
            language: "en",
            apikey: apiToken,
            q: `${category}`,
            size: 10,
        });

        const url = `https://newsdata.io/api/1/latest?${params.toString()}`
        fetch(url)
        .then(res => res.json())
        .then(resObj => {
            const data = resObj.results //resObj.data
            DEBUG && console.log(data)
            const formattedData = [] 
            data.forEach((entry)=>{
                formattedData.push({
                    image_url: entry.image_url,
                    tags: [category,],
                    title: entry.title,
                    published_date: entry.pubDate,
                    description: entry.description,
                    url: entry.link
                })

            })
            APINewsUpdate.current = formattedData
            setUpdateAPINews(true)
        })
        .catch(err => {
            DEBUG && console.error(err)
        });
    }

    const timeMoreThan1hr30mins = (receivedDatetime) => {
        // Convert it to a Date object
        const pastDate = new Date(receivedDatetime);

        // Get the current time
        const now = new Date();

        // Calculate the time difference in milliseconds
        const diffInMs = now - pastDate;

        // Convert 6 hours to milliseconds
        const oneHr30Mins = 90 * 60  * 1000;

        // Check if the difference is greater than 1 hour 30 mins
        return diffInMs > oneHr30Mins
    }
    
    useEffect(()=>{
        const fetchData = async () => {
            try {
                const response = await baseEndPoint.get('/api/api-news/');
                DEBUG && console.log(response)
                setData(response.data.news)

                const last_update_time = response.data.last_update_time
                if (timeMoreThan1hr30mins(last_update_time)){
                    // Custom error to indicate stale data
                    throw new Error("STALE_DATA");
                }
            } catch (err) {
                const status = err?.response?.status
                if ((status === 404) || (err?.message === "STALE_DATA")){
                    getNewsIOData()
                } else{
                    DEBUG && console.log(err)
                    setErrorOnDataLoad(true)
                }
            } 
        }

        fetchData()
        // eslint-disable-next-line
    },[])

    useEffect(()=>{
        const updateNews = async () => {
            try{
                const response = await baseEndPoint.post('/api/update-api-news/',{
                    news: APINewsUpdate.current
                })
                setData(response.data.news)
            }catch(e){ 
                DEBUG && console.log(e?.response.status)
                setErrorOnDataLoad(true)
            }
        }

        if (updateAPINews){
            updateNews()
        }
    },[updateAPINews])

    
    return(
        <section className="homepage-blog-snippet blog-section">
            <h2>Top Stories</h2>

            {/*loading placeholder*/}
            {
                ((data === null) && (errorOnDataLoad===false)) && (
                    <LoadingPlaceholder/>
                )
            }

            {/* story listing */}
            {
                data && (
                    <NewsGrid data={data}/>
                )
            }

            {/*error display*/}
            {
                errorOnDataLoad && (
                    <div 
                        className="error-note"
                        style={{marginTop: "20px"}}
                    >
                        News articles failed to load
                    </div>
                )
            }
        </section>
    )
}

export default HomepageBlogSnippet;